import { ref, onMounted } from 'vue';

export function usePreloader(imageArray) {
  const imagesLoaded = ref(false);
  const showLoadingScreen = ref(false);
  const fadingOut = ref(false);
  const loadedImages = ref([]);
  const promises = [];

  function preloadImages() {
    const delay = parseInt(import.meta.env.LOADING_SCREEN_DELAY || '200', 10);
    const timer = setTimeout(() => {
      if (!imagesLoaded.value) {
        showLoadingScreen.value = true;
      }
    }, delay);

    for (const image of imageArray) {
      let promise;
      promise = new Promise((resolve, reject) => {
        const img = new Image();
        img.src = image.src;
        img.onload = () => {
          loadedImages.value.push(image.src);
          resolve();
        };
        img.onerror = () => reject(image.name);
      });
      promises.push(promise);
    }

    Promise.all(promises)
      .then(() => {
        clearTimeout(timer);
        fadingOut.value = true;
        setTimeout(() => {
          imagesLoaded.value = true;
          showLoadingScreen.value = false;
          fadingOut.value = false;
        }, 500); // Match this with the transition duration
      })
      .catch((imageName) => {
        console.error('Failed to load image:', imageName);
      });
  }

  onMounted(() => {
    preloadImages();
  });

  return {
    imagesLoaded,
    showLoadingScreen,
    fadingOut,
  };
}